import { actionLog } from "../../constants/actionTypes";

const INITIAL_STATE = {
  actionLogsList: [],
  errorData: {},
  csvData: [],
};

const actionLogs = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case actionLog.REQUEST_ACTION_LOGS:
      return {
        ...state,
        actionLogsList: [],
      };
    case actionLog.SUCCESS_ACTION_LOGS:
    case actionLog.SUCCESS_BETWEEN_DATES:
      return {
        ...state,
        actionLogsList: { ...action?.payload?.data },
      };

    case actionLog.ERROR_ACTION_LOGS:
    case actionLog.ERROR_BETWEEN_DATES:
    case actionLog.ERROR_ACTION_LOG_DOWNLOAD:
      return {
        ...state,
        errorData: action?.payload,
      };
    case actionLog.SUCCESS_ACTION_LOG_DOWNLOAD:
      return {
        ...state,
        csvData: action?.payload?.data,
      };
    default:
      return state;
  }
};

export default actionLogs;
